import type { FC, Ref } from "react";
import {
  BasicCard,
  type BasicCardProps,
  type ChildrenProp,
  Flex,
  Separate,
  Spacing,
  Text,
} from "@huub-web/ui";

import type { ViewingTip, ViewingTipCategory } from "../../types";
import { ViewingTipRow } from "./components/ViewingTipRow";

export type ViewingTipsListCardProps = ChildrenProp & {
  category: ViewingTipCategory;
  title: string;
  description?: string;
  icon?: BasicCardProps["icon"];
  tips: ViewingTip[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const ViewingTipsListCard: FC<ViewingTipsListCardProps> = ({
  title,
  tips,
  description,
  children,
  icon = "check",
  ref,
}) => (
  <BasicCard
    ref={ref}
    title={title}
    icon={icon}
    elevated
    border="default"
    indicatorVariant="infoSurface"
  >
    {description && (
      <Text variant="bodyM" color="currentColor50" markdown>
        {description}
      </Text>
    )}
    <Spacing />
    <Flex direction="column" gap="m">
      <Separate>
        {tips.map((tip) => (
          <ViewingTipRow
            key={tip.id}
            id={tip.id}
            description={tip.description}
            advice={tip.advice}
            tips={tip.tips}
          />
        ))}
      </Separate>
    </Flex>
    {children && (
      <>
        <Spacing />
        {children}
      </>
    )}
  </BasicCard>
);
